import { App, DatePicker, Form, Input, InputNumber, Modal, Space } from "antd";
import { CloseSquareFilled, SaveFilled } from '@ant-design/icons';
import { useEffect, useState } from "react";
import execute from "hooks/execute";
import { protectedResources } from "config/msalConfig";
import { get } from "lodash";

export const DataEditor = ({isOpen, dataItem, onDataEditorFinished, onDataEditorCancelled }) => {
    const [form] = Form.useForm();
    const { message } = App.useApp();

    const [emailError, setEmailError] = useState(null);
    

    const checkIfUserWithEmailExists = async (email) => {
          try {
            const response = await execute('GET',`${protectedResources.api.baseEndPoint}/adminUsers/exists/${email}`);
            if(response.success){        
              return response.data;
            }else{
            //   alert(response.message || 'Failed to check if user exists');
              return { exists: false };
            }
          } catch (error) {
            console.error('Error checking if user exists:', error);
            alert('Error checking if user exists: ' + error.message);
            return { exists: false };
          }
    };
      
    const ValidateEmailDomain = async (email) => {
          console.log('custEmail:', email);
          if (!email) {
            setEmailError('Email is required');
          }    
          //  check if email is valid and suffix with domain
          else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            setEmailError('Invalid email format');
          } else{ 
            setEmailError('Checking if user exists...');
            var emailExists = await checkIfUserWithEmailExists(email);
            if(emailExists.exists){
              setEmailError('A user with this email already exists');
            }else {
              setEmailError(null);
              return true;
            }
          }
          return false;
    };

    const handleDataEditFinished = async (values) => {
        console.log("handleDataEditFinished");

        if (!await ValidateEmailDomain(values.adminEmail)) {
            alert('either email is invalid or already exists');
            return;
        }
        var newData = {...dataItem, ...values};
        console.log(newData);
        
        // call  api to add data
        const response = await execute('POST',`${protectedResources.api.baseEndPoint}/adminUsers`, newData);
        if(response.success){   
            message.success("User added successfully");
            newData = {...newData, ...response.data};
        }else{
            message.error(response.message);
            return;
        }
        
        onDataEditorFinished(newData);
    }

    const handleDataEditCancelled = () => {
        console.log("handleDataEditCancelled");
        onDataEditorCancelled();
    }
    
    useEffect(() => {
        if(isOpen){
            form.setFieldsValue(dataItem);
        }
    }, [isOpen, dataItem, form]);

    return (
        <Modal
            open={isOpen}
            title="New Admin User"
            okText={<Space><SaveFilled />Save</Space> }
            cancelText={<Space><CloseSquareFilled />Cancel</Space> }
            okButtonProps={{ autoFocus: true, htmlType: 'submit' }} //form: 'dataEditorForm', key: 'submit'
            onCancel={handleDataEditCancelled}
            destroyOnClose
            modalRender={(dom) => (
                <Form
                  layout="horizontal"
                  form={form}
                  name="dataEditorForm"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  initialValues={{
                    modifier: 'public',
                  }}
                  clearOnDestroy
                  onFinish={handleDataEditFinished}
                >
                  {dom}
                </Form>
            )}>            


            <Form.Item
                name="adminEmail"
                label="User Email"
                rules={[{ required: true, message: 'User Email is required' }]}>
                <Input type="email" />
            </Form.Item>
           
        </Modal>
    );
};